import React from 'react';
import styles from './CompetenceMonthFilter.module.css';

interface CompetenceMonthFilterProps {
  value: string;
  onChange: (value: string) => void;
  className?: string;
  disabled?: boolean;
  ariaLabel?: string;
  max?: string;
}

const CompetenceMonthFilter: React.FC<CompetenceMonthFilterProps> = ({
  value,
  onChange,
  className,
  disabled = false,
  ariaLabel = 'Competência',
  max,
}) => {
  const inputClassName = [styles.input, className ?? ''].filter(Boolean).join(' ');
  const resolvedValue = max && value > max ? max : value;

  return (
    <div className={styles.wrapper}>
      <input
        type="month"
        className={inputClassName}
        value={resolvedValue}
        max={max}
        onChange={(event) => {
          const nextValue = event.target.value;
          if (max && nextValue > max) {
            return;
          }
          onChange(nextValue);
        }}
        disabled={disabled}
        aria-label={ariaLabel}
      />
    </div>
  );
};

export default CompetenceMonthFilter;
